module.exports = __webpack_public_path__ + "static/media/para consulta_Caratula_DishONFP.948493bc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/para consulta_Caratula_DishONFP.pdf
// module id = 778
// module chunks = 0